import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import resourcesToBackend from 'i18next-resources-to-backend';
import config from '../config';

// eslint-disable-next-line import/no-named-as-default-member
i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(resourcesToBackend((language, namespace) => import(`./${language}/${namespace}.json`)))
  .on('failedLoading', (lng, ns, msg) => console.error(msg))
  .on('languageChanged', function (lng) {
    localStorage.setItem('language', lng);
  })
  .init({
    partialBundledLanguages: true,
    resources: {},
    lng: localStorage.getItem('language') ?? navigator.language ?? window.userNavigator.language ?? 'en',
    fallbackLng: 'en',
    fallbackNS: ['core', 'translation'],
    supportedLngs: config.Language.enabled || ['en'],
    interpolation: {
      escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },
    debug: false,
  });

i18n.services.formatter.add('lowercase', (value) => {
  return value.toLowerCase();
});

export { i18n };
